import React, { useState } from 'react';
import { Button, Icon } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { HelpMenuService } from '../../../services/HelpMenu';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { SpinnerIcon } from '../../../components/Commons/SpinnerIcon/styles';
import { addToast } from '../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../store/ducks/toast/types';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { IHelpItem } from '../../../store/ducks/help-center/types';

interface IDownloadHelpButton {
  item: IHelpItem;
}

const DownloadHelpButton: React.FC<IDownloadHelpButton> = ({ item }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { screenName } = getTaggingInformationScreen('help-manuals');

  const onDownloadClick = async (item: IHelpItem) => {
    if (loading) {
      return;
    }
    setLoading(true);

    dispatch(
      sendTagging({
        event: 'click',
        itemDescription: item.taggingItemDescription,
        screenName
      })
    );

    try {
      const base64File = await HelpMenuService.getHelpFile(item.endpoint);
      downloadFile(base64File, item);
      dispatch(
        addToast({
          message: 'Download feito com sucesso',
          type: EToastTypes.SUCCESS
        })
      );

      dispatch(
        sendTagging({
          event: 'click',
          itemDescription: 'manuaisDeAjuda_downloadFeitoComSucesso',
          screenName,
          itemName: 'sucess:download_feito_com_sucesso',
          nonInteraction: true
        })
      );
    } catch (error) {
      dispatch(
        addToast({
          message: 'Não foi possível realizar o download do documento',
          type: EToastTypes.DANGER
        })
      );

      dispatch(
        sendTagging({
          event: 'click',
          itemDescription: 'manuaisDeAjuda_errorNaoFoiPossivelRealizarDownload',
          screenName,
          itemName: 'error:nao_foi_possivel_realizar_download',
          nonInteraction: true
        })
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = (base64File: string, item: IHelpItem) => {
    const dataurl = 'data:text/plain;base64,' + base64File;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute('download', `${item.title}.pdf`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <Button
      key={item.endpoint}
      variant="tertiary"
      iconPosition="right"
      icon={
        loading ? (
          <SpinnerIcon style={{ marginRight: '0.2rem' }} />
        ) : (
          <Icon option="Download" />
        )
      }
      fullWidth
      name={item.title}
      onClick={() => onDownloadClick(item)}
    >
      {item.title}
    </Button>
  );
};

export default DownloadHelpButton;
